import { InjectionToken } from '@angular/core';
import { CookieStorage } from './interfaces';

export const COOKIE_STORAGE_ADAPTER = new InjectionToken<CookieStorage>('CookieStorageAdapter');
